'use strict';

module.exports = /*@ngInject*/ function () {
    var factory = {};
    var tripList = [];
    var tripInformation = new Map();

    factory.clearList = function() {
        tripList = [];
        tripInformation = new Map();
    };
    factory.addToList = function(id, object){
        if(tripList.indexOf(id) === -1) {
            tripList.push(id);
            tripList = tripList.sort();
        }
        tripInformation.set(id, object);
    };
    factory.removeFromList = function(id){
        var index = tripList.indexOf(id);
        if(index !== -1) {
            tripList.splice(index, 1);
            tripList = tripList.sort();
            tripInformation.delete(id);
        }
    };

    factory.getPreviousId = function(id){
        var index = tripList.indexOf(id);
        if(index-1 >= 0) {
            return tripList[index-1];
        }
    };

    factory.getNextId = function(id){
        var index = tripList.indexOf(id);

        if(index+1 < tripList.length) {
            return tripList[index+1];
        }
    };

    factory.getInformation = function(id) {
        return tripInformation.get(id);
    };

    factory.getInformationMap = function(){
        return tripInformation;
    };

    factory.getList = function(){
        return tripList;
    };

    factory.setList = function(list){
        tripList = list;
    };

    return factory;
};